const aosDelayElements = document.querySelectorAll<HTMLElement>('.term_posts a');

document.addEventListener('aos:in', ({ detail }) => {
    aosDelayElements.forEach(element => {
        if (element === detail) {
            const delay = element.style.transitionDelay;
            if (delay) setTimeout(() => element.style.transitionDelay = '0ms', parseInt(delay));
        }
    });
});